import React, { createElement, CSSProperties, FC, ReactChild, ReactNode } from 'react';
import {
  StyledParagraph1,
  StyledParagraph2,
  StyledParagraph3,
  StyledParagraph4,
  StyledParagraph5,
} from './styles';

export interface Props {
  level: 1 | 2 | 3 | 4 | 5;
  upperCase?: boolean;
  bottom?: number;
  top?: number;
  left?: number;
  right?: number;
  color?: string;
  fontWeight?: 400 | 500 | 600 | 700;
  style?: CSSProperties;
  children: ReactChild | ReactChild[] | ReactNode;
}

const Paragraph: FC<Props> = ({
  children,
  level,
  upperCase = false,
  bottom = 0,
  top = 0,
  left = 0,
  right = 0,
  color,
  fontWeight = 400,
  style,
}) => {
  const elements = {
    1: StyledParagraph1,
    2: StyledParagraph2,
    3: StyledParagraph3,
    4: StyledParagraph4,
    5: StyledParagraph5,
  };

  return createElement(
    elements[level],
    { upperCase, bottom, top, left, right, color, fontWeight, style },
    children,
  );
};

export default React.memo(Paragraph);
